import './About.css';

const PARTNERS = [
  {
    key: 'senac',
    logo: '/images/logo-senac.png',
    name: 'Senac — Incubadora I.D.E.I.A.S',
    desc: 'A Startup com o Tarefas Perto integra o programa de incubação da Incubadora I.D.E.I.A.S do Senac, recebendo apoio estratégico para acelerar o desenvolvimento da startup, validar soluções inovadoras e fortalecer sua atuação no mercado.',
    items: [
      { emoji: '🏢', label: 'Startup incubada pelo Senac' },
      { emoji: '💼', label: 'Estrutura e suporte especializado' },
      { emoji: '👨‍🏫', label: 'Mentorias estratégicas' },
      { emoji: '📚', label: 'Capacitações e desenvolvimento' },
      { emoji: '🤝', label: 'Conexão com o ecossistema de inovação' },
      { emoji: '✅', label: 'Validação e crescimento do negócio' },
    ],
  },
  {
    key: 'sebrae-startup-ne',
    logos: [
      { src: '/images/logo-sebrae.svg', alt: 'Sebrae' },
      { src: '/images/logo-startup-ne.avif', alt: 'Startup NE' },
    ],
    name: 'Sebrae + Startup NE',
    desc: 'O Tarefas Perto foi uma das 80 startups selecionadas no edital do Startup NE em Pernambuco, iniciativa do Sebrae voltada ao fortalecimento de negócios inovadores no Nordeste. Durante o programa, passamos por mentorias, capacitações estratégicas e processos de validação, acelerando nosso crescimento e conexão com o ecossistema de inovação.',
    items: [
      { emoji: '🚀', label: 'Startup selecionada pelo Startup NE Pernambuco' },
      { emoji: '📈', label: 'Programa de aceleração do Sebrae' },
      { emoji: '👨‍🏫', label: 'Mentorias estratégicas' },
      { emoji: '📚', label: 'Capacitações e desenvolvimento' },
      { emoji: '✅', label: 'Validação do modelo de negócio' },
      { emoji: '🌐', label: 'Conexão com o ecossistema de inovação' },
      { emoji: '🤝', label: 'Networking com especialistas e startups' },
    ],
  },
  {
    key: 'facepe',
    logo: '/images/logo-facepe.png',
    name: 'FACEPE — Pró-Startups Operação',
    desc: 'O Tarefas Perto passou pelo Edital – Pró-Startups Operação da FACEPE, recebendo apoio de bolsa para investimento no desenvolvimento da plataforma ao longo de 2025, fortalecendo a evolução do produto e a consolidação da nossa solução inovadora.',
    items: [
      { emoji: '🏛️', label: 'Edital Pró-Startups Operação (FACEPE)' },
      { emoji: '💰', label: 'Bolsa para investimento na plataforma' },
      { emoji: '📱', label: 'Desenvolvimento e evolução do produto' },
      { emoji: '✅', label: 'Validação de soluções inovadoras' },
      { emoji: '🔬', label: 'Fomento à ciência, tecnologia e inovação' },
      { emoji: '📈', label: 'Fortalecimento do crescimento em 2025' },
    ],
  },
];

export function About() {
  return (
    <>
      <section className="about-section">
        <div className="container">
          <div className="about-badge">Sobre Nós</div>
          
          <div className="about-content">
            <div className="about-image">
              <img src="/images/robot-ai.jpg" alt="Inteligência Artificial" />
            </div>
            
            <div className="about-info">
              <h2>Tornamos seu Negócio mais Inteligente com Inteligência Artificial</h2>
              
              <p className="about-description">
                Potencialize sua empresa com soluções inovadoras baseadas em IA. Automatize processos, 
                otimize operações e alcance novos patamares de eficiência com tecnologia de ponta.
              </p>
              
              <div className="about-features">
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Inovação com IA</span>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Equipe Especializada</span>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Suporte Estratégico</span>
                </div>
                
                <div className="feature-item">
                  <i className="fas fa-check"></i>
                  <span>Soluções Acessíveis</span>
                </div>
              </div>
              
              <div className="about-cta">
                <a href="#servicos" className="read-more-btn">Saiba Mais</a>
                
                <div className="social-links">
                  <a href="#" className="social-link"><i className="fab fa-facebook-f"></i></a>
                  <a href="#" className="social-link"><i className="fab fa-twitter"></i></a>
                  <a href="https://www.instagram.com/decodebyte?igsh=MTljZGNyYzNla3Jlbw%3D%3D&utm_source=qr" className="social-link" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                  <a href="#" className="social-link"><i className="fab fa-linkedin-in"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h1>Nosso Time</h1>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <img src="/images/member1.jpeg" alt="James William" />
              </div>
              <h3>James William</h3>
              <p className="member-role">CEO & Fundador</p>
              <p className="member-bio">
                Graduado em Análise e Desenvolvimento de Sistemas e pós-graduação em Data Science. 
                Com experiência em desenvolvimento de aplicativos móveis e soluções escaláveis, 
                além de experiência em gestão de projetos e liderança de equipes.
              </p>
            </div>

            <div className="team-member">
              <div className="member-image">
                <img src="/images/member2.jpeg" alt="Stefano Spencer" />
              </div>
              <h3>Stefano Spencer</h3>
              <p className="member-role">CTO & Fundador</p>
              <p className="member-bio">
                Graduado em Análise e Desenvolvimento de Sistemas, especialista em desenvolvimento 
                de aplicativos móveis e inteligência artificial. Como CTO, ele supervisiona o 
                desenvolvimento tecnológico, garantindo qualidade e inovação.
              </p>
            </div>

            <div className="team-member">
              <div className="member-image">
                <img src="/images/member3.jpeg" alt="Renato Dozzo" />
              </div>
              <h3>Renato Dozzo</h3>
              <p className="member-role">COO & Fundador</p>
              <p className="member-bio">
                Graduado em Ciências Contábeis e especialista em Gestão de Negócios. Como COO, 
                ele gerencia as operações da empresa com foco em eficiência e sustentabilidade, 
                otimizando processos internos e mantendo a alta performance financeira.
              </p>
            </div>
      </div>
    </div>
      </section>

      <section className="hp-credibility" id="credibilidade">
        <div className="hp-container">
          <h2>
            Apoio <span className="hp-gradient-text">Institucional</span>
          </h2>
          <p className="hp-section-desc">
            O Tarefas Perto conta com o apoio de instituições que impulsionam inovação, tecnologia e empreendedorismo, fortalecendo nossa expansão.
          </p>

          <div className="hp-partners-grid">
            {PARTNERS.map(partner => (
              <div key={partner.key} className="hp-partner-card">
                <div className="hp-partner-card__header">
                  <div className={`hp-partner-card__logo-wrapper ${partner.logos ? 'hp-partner-card__logo-wrapper--dual' : ''} ${partner.key === 'facepe' ? 'hp-partner-card__logo-wrapper--facepe' : ''}`}>
                    {partner.logos ? (
                      partner.logos.map(logo => (
                        <img key={logo.alt} src={logo.src} alt={logo.alt} className="hp-partner-card__logo" />
                      ))
                    ) : (
                      <img src={partner.logo} alt={partner.name} className="hp-partner-card__logo" />
                    )}
                  </div>
                  <h3>{partner.name}</h3>
                </div>

                <p className="hp-partner-card__desc">{partner.desc}</p>

                <ul className="hp-partner-card__list">
                  {partner.items.map(item => (
                    <li key={item.label} className="hp-partner-card__list-item">
                      <span className="hp-partner-card__bullet">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                      <span>{item.label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
} 